<template>
    <div id="editEmployee" class="content">
        <h4>{{ title }}</h4>
        <hr>
        <div class="row">
            <div class="col-sm-11">
                <form class="form" @submit.prevent="updateEmployee">
                    <div class="form-group row">
                        <div class="col-sm-2" >
                            <label class="control-label" for="full_name">{{ label.full_name }}</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" required id="full_name" name="full_name" v-model="employee.employee_name" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="staff_id">{{ label.staff_id }}</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control"  id="staff_id" name="staff_id" v-model="employee.staff_id" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="company">{{ label.company }}</label>
                        </div>

                        <div class="col-sm-8">
                            <select class="form-control" id="company" name="company" required v-model="employee.company_id">
                                <option v-bind:value="employee.company_id" selected>{{ employee.company_name }}</option>
                                <option v-for="(company, index) in companies" :key="index" v-bind:value="company.id">{{ company.display_name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="email">{{ label.email }}</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="email" class="form-control" required id="email" name="email" v-model="employee.email" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="New IC">{{ label.new_ic }}</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="new_id" name="new_ic" v-model="employee.card_id" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="created_at">{{ label.created_at }}</label>
                        </div>
                        <div class="col-sm-3">
                            <input type="date" class="form-control" id="created_at" name="created_at" required v-model="employee.created_at" >
                        </div>
                        <div class="col-sm-2">
                            <label class="control-label" for="ended_at">{{ label.ended_at }}</label>
                        </div>
                        <div class="col-sm-3">
                            <input type="date" class="form-control" id="ended_at" name="ended_at" required v-model="employee.ended_at" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="id_number">{{ label.id_number }}</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="id_number" name="id_number" v-model="employee.id_number" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-2">
                            <label class="control-label" for="passport">{{ label.passport }}</label>
                        </div>
                        <div class="col-sm-8">
                            <table class="table table-bordered">
                                <tr class="passport_number_table">
                                    <th>{{ label.passport_number }}</th>
                                    <th>{{ label.passport_v }}</th>
                                    <th>{{ label.passport_e }}</th>
                                </tr>
                                <tr>
                                    <td><input type="text" class="form-control" id="passport_number" name="passport_number" v-model="employee.passport" ></td>
                                    <td><input type="date" class="form-control" id="valid_from" name="valid_from" v-model="employee.passport_issued"></td>
                                    <td><input type="date" class="form-control" id="expiry_date" name="expiry_date" v-model="employee.passport_expiry"></td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="form-group row">
                        <!--div class="col-sm-2">
                            <label class="control-label" for="can_batch">{{ label.can_batch }}</label>
                        </!--div>
                        <div class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="can_batch_options" id="batch_yes" value="1" v-model="employee.can_batch">
                                <label class="form-check-label" for="inlineRadio1">{{ label.batch_yes }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="can_batch_options" id="batch_no" value="0" v-model="employee.can_batch">
                                <label class="form-check-label" for="inlineRadio2">{{ label.batch_no }}</label>
                            </div>
                        </div -->

                        <div class="col-sm-2">
                            <label class="control-label" for="can_login">{{ label.can_login }}</label>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="can_login_options" id="login_yes" value="1" v-model="employee.can_login">
                                <label class="form-check-label" for="inlineRadio1">{{ label.login_yes }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="can_login_options" id="login_no" value="0" v-model="employee.can_login">
                                <label class="form-check-label" for="inlineRadio2">{{ label.login_no }}</label>
                            </div>
                        </div>

                        <div class="col-sm-2">
                            <label class="control-label" for="logged_in">{{ label.logged_in }}</label>
                        </div>

                        <div class="col-sm-3">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="logged_in_options" id="logged_in_yes" value="1" v-model="employee.logged_in">
                                <label class="form-check-label" for="inlineRadio1">{{ label.logged_in_yes }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="logged_in_options" id="logged_in_no" value="0" v-model="employee.logged_in">
                                <label class="form-check-label" for="inlineRadio2">{{ label.logged_in_no }}</label>
                            </div>
                        </div>
                    </div>

                     <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="can_geolocation">{{ label.can_geolocation }}</label>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="can_geolocation_options" id="can_geolocation_yes" value="1" v-model="employee.can_geolocation">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.can_geolocation_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="enable_options" id="can_geolocation_no" checked="checked" value="0" v-model="employee.can_geolocation">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.can_geolocation_no }}</label>
                                </div>
                            </div>
                        </div>

                    <div class="form-group row text-center">
                        <div class="col-sm-11">
                            <button type="submit" class="btn btn-primary" >SAVE</button>
                            <router-link :to="`/${$i18n.locale}/employee`"><button class="btn btn-primary">CANCEL</button></router-link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return {
          title: 'EDIT STAFF',
          label: {
                full_name: 'FULL NAME',
                staff_id: 'STAFF ID',
                company: 'COMPANY',
                email: 'EMAIL',
                new_ic: 'NEW IC',
                created_at: 'ACTIVE FROM',
                ended_at: 'ACTIVE UNTIL',
                id_number: 'ID',
                passport: 'PASSPORT',
                passport_number: 'NUMBER',
                passport_v: 'VALID FROM',
                passport_e: 'EXPIRY DATE',
                can_batch: 'MANAGE BATCH CLOCKING',
                batch_yes: 'YES',
                batch_no: 'NO',
                can_login: 'CAN LOGIN',
                login_yes: 'YES',
                login_no: 'NO',
                logged_in: 'LOGGED IN',
                logged_in_yes: 'YES',
                logged_in_no: 'NO',
                can_geolocation: 'GEOFENCING',
                can_geolocation_yes: 'YES',
                can_geolocation_no: 'NO',
            },
            id: this.$route.params.id,
            employee: {
                employee_name: null,
                staff_id: null,
                company_id: null,
                company_name: null,
                email: null,
                card_id: null,
                created_at: null,
                ended_at: null,
                id_number: null,
                passport: null,
                passport_issued: null,
                passport_expiry: null,
                can_batch: [],
                can_login: [],
                logged_in: null,
                can_geolocation: []
            },
            companies: [],
            validationMsg: '',
            status: '',
        }
    },

    methods: {
        loadEmployee() {
            var vm = this
            var moment = require('moment')

            axios.get(this.$store.getters.rootAPI + '/user/'+ vm.id)
            .then(function (response) {
                var employee = response.data.rec[0]
                vm.employee.employee_name = employee.employee_name
                vm.employee.staff_id = employee.staff_id
                vm.employee.company_id = employee.company_id
                vm.employee.company_name = employee.company_name
                vm.employee.email = employee.email
                vm.employee.card_id = employee.card_id
                vm.employee.created_at = moment(employee.effective_at).format('YYYY-MM-DD')
                vm.employee.ended_at = moment(employee.effective_till).format('YYYY-MM-DD')
                vm.employee.id_number = employee.id_number
                vm.employee.passport = employee.passport
                vm.employee.passport_issued = moment(employee.passport_issued).format('YYYY-MM-DD')
                vm.employee.passport_expiry = moment(employee.passport_expiry).format('YYYY-MM-DD')
                vm.employee.can_batch = employee.can_batch,
                vm.employee.can_login = employee.can_login,
                vm.employee.logged_in = employee.logged_in,
                vm.employee.can_geolocation = employee.can_geolocation
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error
            })
        },

        loadCompanies() {
            var vm = this

            axios.get(this.$store.getters.rootAPI + '/companies')
            .then(function (response) {
                vm.companies = response.data.rec
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error
            })
        },

        updateEmployee() {
            var vm = this
            let route = '/' + this.$i18n.locale + '/employee'
            
            axios.put(this.$store.getters.rootAPI + '/employee/'+ vm.id, {
                display_name: vm.employee.employee_name,
                staff_id: vm.employee.staff_id,
                company_id: vm.employee.company_id,
                email: vm.employee.email,
                effective_at: vm.employee.created_at,
                effective_till: vm.employee.ended_at,
                card_id: vm.employee.card_id,
                id_number: vm.employee.id_number,
                passport: vm.employee.passport,
                passport_issued: vm.employee.passport_issued,
                passport_expiry: vm.employee.passport_expiry,
                can_batch: vm.employee.can_batch,
                can_login: vm.employee.can_login,
                logged_in: vm.employee.logged_in,
                can_geolocation: vm.employee.can_geolocation
            })
            .then(function (response) {
                console.log(response)
                vm.status = response.data.status

                if(vm.status === 'success') {
                    vm.$router.push(route)
                }

                if(response.data.errors.length > 0)
                {
                    vm.validationMsg = response.data.errors[0].msg
                    alert('Validation error. ' + vm.validationMsg)
                }
            })
            .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })

        },
    },
    created() {
        this.loadEmployee()
        this.loadCompanies()
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/employee/EditEmployee.vue